export function roundToThreeDecimals(value: number) {
  return Math.round(value * 1000) / 1000;
}

export function formatNumber(value: number | undefined | null): string {
  if (value === undefined || value === null) return '0.00';
  return value.toLocaleString(undefined, { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
}
